import Joi from "joi";
import { purchaseOrderLineSchema } from "./purchaseOrderLine";

export const purchaseOrderSchema = Joi.object({
  description: Joi.string().min(2).label("Description"),
  status: Joi.number().min(0).label("Description"),
  vendorId: Joi.string().min(2).label("Vendor"),
  // code: Joi.string().min(2).label("Code"),
  purchaseOrderTypeId: Joi.string().min(2).label("Purchase Order Type"),
  date: Joi.date().required(),
  requestForQuotation: Joi.boolean().required(),
  purchaseOrderLines: Joi.array()
    .items(purchaseOrderLineSchema)
    .min(1)
    .required()
    .label("Purchase Order Lines"),
  hasInvoice: Joi.boolean().required(),
});
